module.exports = __webpack_public_path__ + "img/kayamayuzo.3a381aa6.png";